// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IqKi","fullView":"styles_fullView__2t93d"};